// import firebaseConfig from "./firebase";

import { REALTIME_CHANNELS, REALTIME_EVENTS } from "./realtime";

if (process.env.NODE_ENV === "production") {
  const variables = [
    "REACT_APP_BASE_URL",
    "REACT_APP_IRISK_URL",
    "REACT_APP_VISAL_URL",
    "REACT_APP_KEK_URL",
    "REACT_APP_PLACE_IT_ASSET_URI"
  ];
  for (let variable of variables) {
    if (!process.env[variable]) {
      throw new Error(`Kindly Provide Variable ${variable} In Env`);
    }
  }
}

interface Config {
  env: "production" | "staging" | "sandbox" | "test" | "development";
  asset: {
    uri: string;
    placeItUri: string;
    visalUri: string;
    kekUri: string;
    backendUri: string;
  };
  rollbar: {
    accessToken: string;
    environment: string;
  };
  pusher: {
    keys: {
      kek_key: string;
      visal_key: string;
      sample: string;
    };
    cluster: string;
    channel: string;
    event: string;
    //     export const PUSHER_KEY = "6732a1bd9862dfe49492";
    // export const PUSHER_CLUSTER = "eu";
    // export const CHANNEL = "LgzULSz64aed7WJ7YwDq3qmHAeX786dZNZ3Ko4Bisf0";
    // export const EVENT = "LgzULSz64aed7WJ7YwDq3qmHAeX786dZNZ3Ko4Bisf0-event";
  };
  realtime: {
    events: typeof REALTIME_EVENTS;
    channels: typeof REALTIME_CHANNELS;
  };
}

const config: Config = {
  env: (process.env.NODE_ENV as any) ?? "development",
  asset: {
    uri: process.env.REACT_APP_ASSET_URI ?? "http://127.0.0.1:4000/api/assets",
    placeItUri:
      process.env.REACT_APP_PLACE_IT_ASSET_URI ??
      "http://127.0.0.1:4000/api/assets",
    visalUri:
      process.env.REACT_APP_VISAL_URL ?? "http://localhost:4000/api/assets",
    kekUri:
      process.env.REACT_APP_KEK_ASSET_URI ?? "http://localhost:4000/api/assets",
    backendUri:
      process.env.REACT_APP_BASE_URL ?? "http://localhost:4000/api/assets",
  },
  rollbar: {
    accessToken:
      process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN ??
      "8d39d770f871429cbab76380a6882853",
    environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT ?? "testenv",
  },
  pusher: {
    channel:
      process.env.REACT_APP_PUSHER_CHANNEL ??
      "LgzULSz64aed7WJ7YwDq3qmHAeX786dZNZ3Ko4Bisf0",
    cluster: process.env.REACT_APP_PUSHER_CLUSTER ?? "eu",
    keys: {
      kek_key: process.env.REACT_APP_PUSHER_KEY__KEK ?? "8fdc449c93173e31d8a2",
      visal_key:
        process.env.REACT_APP_PUSHER_KEY__VISAL ?? "6732a1bd9862dfe49492",
      sample:
        process.env.REACT_APP_PUSHER_KEY__SAMPLE ?? "17ab537f0f3b7c9d8a9a",
    },
    event:
      process.env.REACT_APP_PUSHER_EVENT ??
      "LgzULSz64aed7WJ7YwDq3qmHAeX786dZNZ3Ko4Bisf0-event",
  },
  realtime: {
    events: REALTIME_EVENTS,
    channels: REALTIME_CHANNELS,
  },
};

export default config;
